import React from 'react';
import MediaLibrary from '../../components/mediaLibrary/MediaLibrary';

const MediaLibraryView = () => (
    <div className="b-media-library-view">
        <MediaLibrary />
    </div>
);

export default MediaLibraryView;
